import { generateHash } from 'src/features/flows/lib/general';

export function genQueryKey(...args: (string | number)[]) {
  return generateHash(args.join(''), 10);
}

export function sleep(time = 500) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function minsToMillis(minutes: number) {
  return minutes * 60 * 1000;
}

/**
 * Parses a pathname (/foo/bar?john=doe) variable and returns the path at the given depth. F.e. depth 0 return "foo"
 *
 * @param {string} path - The full pathname from which to extract the variable.
 * @param {number} depth - The depth of the path segment to return (0-based).
 * @returns {string} The path segment at the specified depth, or undefined if the depth is out of bounds.
 *
 * @example
 * // Returns 'users'
 * getPathVariable('/api/v1/users/123/profile', 2);
 *
 * @example
 * // Returns undefined (depth out of bounds)
 * getPathVariable('/api/v1/users/123/profile', 5);
 */
export function getPathVariable(path: string, depth: number): string {
  return path.split('?')[0].split('/')[depth + 1];
}

/**
 * Removes properties with `undefined` values from an object. Only goes one level deep.
 * Useful for prisma updates and req.body cleansing
 *
 * @template T
 * @param {T} obj - The object to be cleansed.
 * @returns {T} The cleansed object with `undefined` values removed.
 */
export function cleanseObject<T>(obj: T): T {
  for (const key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  }
  return obj;
}
